<template>
  <div>
    <h1 class="heading title is-4" style="color: gray;">Bitcoin Fountain</h1>
    <h1 class="subtitle is-6" style="color: gray;">A visualizer for unconfirmed Bitcoin transactions that utilizes particle physics to render a fountain. Displays new transactions as they are emitted by a Bitcoin node.</h1>
    <h1 class="subtitle is-6" style="color: gray;">Stream data courtesy of <a target="_blank" href="https://www.blockchain.com/">https://www.blockchain.com</a></h1>
    <h1 class="subtitle is-6" style="color: gray;">Particle physics library adapted from <a target="_blank" href="http://google.github.io/liquidfun/">Google's Liquid Fun library</a></h1>
  </div>
</template>

<script>
  export default {
    name: "BitcoinFountainDescription"
  }
</script>

<style scoped>

</style>
